import React, {FC} from 'react';

import {TeammateModel} from '../../../../libs/shared/core/src/models/api/teammateModel';
import {sortCustomAttributes} from '../../../helpers/customFieldHelpers';
import {CardAttributeUpdateAction} from '../../../helpers/models/cardAttributeUpdateHelpers';
import {CardModel} from '../../../models/api/cardModel';
import {CustomAttributeModel} from '../../../models/api/customFieldModel';
import {CustomAttributeContainer} from './customAttributeContainer';

/*
 * Types.
 */

interface CustomAttributesSectionProps {
  customAttributes: ReadonlyArray<CustomAttributeModel>;
  teammates: ReadonlyArray<TeammateModel>;
  card?: CardModel;
  updateCardAttributeAsync: (action: CardAttributeUpdateAction) => Promise<void>;
  updateUnsavedCard: (action: CardAttributeUpdateAction) => void;
}

/*
 * Component.
 */

export const CustomAttributesSection: FC<CustomAttributesSectionProps> = (props) => {
  const {customAttributes, teammates, card, updateCardAttributeAsync, updateUnsavedCard} = props;

  return (
    <>
      {sortCustomAttributes(customAttributes).map((customAttribute) => (
        <CustomAttributeContainer
          key={customAttribute.customField.id}
          customAttribute={customAttribute}
          teammates={teammates}
          card={card}
          updateCardAttributeAsync={updateCardAttributeAsync}
          updateUnsavedCard={updateUnsavedCard}
        />
      ))}
    </>
  );
};
